<template>
  <v-app id="app">
    <v-navigation-drawer v-model="drawer" dark left app>
      <v-divider></v-divider>

      <v-list v-if="admin">
        <v-list-item-group v-model="selectedItem">
          <v-list-item
            v-for="item in adminmenuitems"
            :key="item.index"
            link
            :to="item.link"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="subtitle-2">{{
                item.title
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>

      <v-list v-if="!admin">
        <v-list-item-group v-model="selectedItem">
          <v-list-item
            v-for="item in customermenuitems"
            :key="item.index"
            link
            :to="item.link"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="subtitle-2">{{
                item.title
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-list v-if="!user"> </v-list>
    </v-navigation-drawer>

    <v-app-bar app flat dense v-if="toolbar" class="grey darken-3">
      <v-app-bar-nav-icon class="white--text" @click="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title class="title font-weight-bold white--text"
        >Definedge Dashboard
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-toolbar-items class="hidden-xs-only ml-4 px-2">
        <v-icon  class="white--text"  @click="changeTheme">fas fa-moon</v-icon>
      </v-toolbar-items>

      <!-- <v-toolbar-items class="hidden-xs-only ml-4 px-2"> -->
        <v-toolbar-items class="ml-4 px-2">
        <!-- <v-icon @click="onLogout">fas fa-sign-out-alt</v-icon> -->

        <v-container fluid style="height: 300px">
          <v-row justify="center">
            <v-menu bottom min-width="200px" rounded offset-y>
              <template v-slot:activator="{ on }">
                <v-btn icon x-large v-on="on">
                  <v-avatar color="gray white--text">
                    <v-icon dark> mdi-account-circle </v-icon>
                  </v-avatar>
                </v-btn>
              </template>
              <v-card>
                <v-list-item-content class="justify-center">
                  <div class="mx-auto text-center">
                    <h3>{{ firstname }}</h3>
                    <p class="text-caption mt-1">
                      {{ email }}
                    </p>
                    <v-divider class="my-3"></v-divider>
                    <v-btn depressed rounded text @click="onLogout">
                      <v-icon >fas fa-sign-out-alt</v-icon>
                      Sign Out
                    </v-btn>
                  </div>
                </v-list-item-content>
              </v-card>
            </v-menu>
          </v-row>
        </v-container>
      </v-toolbar-items>
    </v-app-bar>

    <v-main>
      <v-container class="py-8 px-6" fluid>
        <transition name="slide" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    cards: ["Today", "Yesterday"],
    drawer: true,
    
    //toolbar: this.toolbarstatus,
    selectedItem: 0,
    link: "",
    customermenuitems: [
      { icon: "fas fa-home", title: "Dashboard", link: "/" },
      { icon: "fas fa-user", title: "Profile", link: "/profile" },
      // { icon: "fab fa-delicious", title: "Buy Product", link: "/buy-product" },
      {
        icon: "fas fa-shopping-cart",
        title: "Buy Product",
        link: "/buy-product",
      },
      {
        icon: "fas fa-credit-card",
        title: "Subscriptions",
        link: "/subscriptions",
      },
      // {
      //   icon: "fab fa-intercom",
      //   title: "Data Subscriptions",
      //   link: "/data-subscriptions",
      // },
      {
        icon: "fas fa-search",
        title: "Payment History",
        link: "/payment-history",
      },
      
    ],
    adminmenuitems: [
      { icon: "fas fa-home", title: "Dashboard", link: "/" },
      { icon: "fas fa-user", title: "Profile", link: "/profile" },
      {
        icon: "fas fa-percent",
        title: "Discount Master",
        link: "/discount-master",
      },
      {
        icon: "fab fa-delicious",
        title: "Product Master",
        link: "/product-master",
      },
      {
        icon: "fas fa-credit-card",
        title: "Customer Payments",
        link: "/customer-payments",
      },
      {
        icon: "fab fa-intercom",
        title: "Customer Subscriptions",
        link: "/customer-subs",
      },
      {
        icon: "fas fa-search",
        title: "Customer Search",
        link: "/customer-search",
      },
      {
        icon: "fas fa-file-invoice",
        title: "Invoice",
        link: "/customer-invoice",
      },
      {
        icon: "fas fa-users",
        title: "Associate Master",
        link: "/associate-master",
      },
      { icon: "fas fa-link", title: "Referral Program", link: "/referral" },
      { icon: "fas fa-map-pin", title: "Leads", link: "/leads" },
    ],
  }),
  methods: {
    onLogout() {
      window.location.assign("/logout");
    },

    login() {
      window.location.assign("/ssologin");
    },

    changeTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    },
  },
  created() {
    if (!this.$store.getters.user) {
      //console.log("Created fun in app.vue if block");
      this.drawer = false;
      this.toolbar = false;
      this.changeTheme();
    } else if (this.phone == null) {
      //console.log("mobile number empty and in app.vye else if block");
      this.drawer = false;
      this.toolbar = false;
      //this.changeTheme()
    } else {
      //console.log("MOBILE number NOT EMPTY and in app.vye else block");
      this.drawer = true;
      this.toolbar = true;
    }
  },
  computed: {
    ...mapState({
      phone: (state) => state.username.phone,
      firstname: (state) => state.username.firstname,
      lastname: (state) => state.username.lastname,
      email: (state) => state.username.email,
    }),

    toolbar() {
      if (this.phone == null) {
        return false;
      } else {
        return true;
      }
    },
 
    admin() {
      return this.$store.getters.admin;
    },
    user() {
      return this.$store.getters.user;
    },
    userdata() {
      return this.$store.getters.userdata;
    },
  },
  watch: {
    toolbar: function () {
      this.drawer = true;
    },
  },
};
</script>

<style scoped>
.slide-enter-active {
  animation: slide-in 200ms ease-out forwards;
}
.slide-leave-active {
  animation: slide-out 200ms ease-out forwards;
}

@keyframes slide-in {
  from {
    transform: translateY(-30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-30px);
    opacity: 0;
  }
}
</style>
